import React from 'react';
import { View } from 'react-native-web';
import SquareBar from '../Shapes/SquareBar';
import Square from '../Shapes/Square';
import RoundBar from '../Shapes/RoundBar';
import Circle from '../Shapes/Circle';

//= ========================================================================

const RadiusBar = ({
  globJSON, onConfigChanged, isSquare, isSelected,
}) => {
  const onRadiusChanged = (value) => {
    globJSON.configurations.theme.radius.elements_shape_square = value;
    onConfigChanged();
  };

  return (

    <View>
      {isSquare
        ? (
          <View style={{ flexDirection: 'row', marginRight: 30 }}>
            <SquareBar isSelected={isSelected} onPress={() => { onRadiusChanged(isSquare); }} />
            <Square isSelected={isSelected} onPress={() => { onRadiusChanged(isSquare); }} />
          </View>
        ) : (
          <View style={{ flexDirection: 'row' }}>
            <RoundBar isSelected={isSelected} onPress={() => { onRadiusChanged(isSquare); }} />
            <Circle isSelected={isSelected} onPress={() => { onRadiusChanged(isSquare); }} />
          </View>
        )}
    </View>
  );
};
export default RadiusBar;
